import { EVENT, EVENT_CATEGORY } from '../../constants'

export class GtmBaseModel {
  constructor({ event, eventCategory } = {}) {
    this.event = event || EVENT
    this.event_category = eventCategory || EVENT_CATEGORY
  }
}
